const footerLinks = [
  { label: 'Início', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Áreas de Atuação', href: '#atuacao' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

const areas = ['Inventário', 'Usucapião', 'Regularização de Imóveis', 'Direito Imobiliário'];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0C3A22] text-white">
      {/* Top gold bar */}
      <div className="w-full h-0.5 bg-gradient-to-r from-transparent via-[#C7A76C] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2 flex flex-col gap-5">
            <img
              src="https://storage.readdy-site.link/project_files/66d90ef2-528e-4451-823d-a1eab56ea0b6/8877739b-eaeb-4a42-9522-eb394f9d4bf0_erasebg-transformed.png?v=b2a00aa3046b2995abfdefea9bf1f914"
              alt="Bruno Castro Advocacia e Consultoria"
              className="h-12 w-auto object-contain object-left"
            />
            <p className="font-sans text-white/55 text-sm leading-relaxed max-w-sm">
              Especialistas em inventário, herança e direito imobiliário no Grande ABC Paulista.
              Protegemos seu patrimônio com segurança jurídica e dedicação.
            </p>
            <div className="flex gap-3">
              <a
                href="https://wa.me/5511958814422"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/8 hover:bg-[#C7A76C]/20 text-white/60 hover:text-[#C7A76C] transition-all duration-200 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/brunocastro_adv/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/8 hover:bg-[#C7A76C]/20 text-white/60 hover:text-[#C7A76C] transition-all duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-col gap-4">
            <h4 className="font-serif text-white font-semibold text-base">
              <a href="#hero" onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}>
                Navegação
              </a>
            </h4>
            <nav className="flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="font-sans text-white/50 hover:text-[#C7A76C] text-sm transition-colors duration-200 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div className="flex flex-col gap-4">
            <h4 className="font-serif text-white font-semibold text-base">
              <a href="#atuacao" onClick={(e) => { e.preventDefault(); handleNavClick('#atuacao'); }}>
                Áreas de Atuação
              </a>
            </h4>
            <nav className="flex flex-col gap-2.5">
              {areas.map((area) => (
                <a
                  key={area}
                  href="#atuacao"
                  onClick={(e) => { e.preventDefault(); handleNavClick('#atuacao'); }}
                  className="font-sans text-white/50 hover:text-[#C7A76C] text-sm transition-colors duration-200 cursor-pointer"
                >
                  {area}
                </a>
              ))}
            </nav>
          </div>
        </div>

        {/* Contact info row */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap items-center gap-6 text-sm">
          <div className="flex items-center gap-2 text-white/50">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-line text-[#C7A76C] text-sm"></i>
            </div>
            <span className="font-sans">Alameda Terracota, 185 - sala 1213, São Caetano do Sul — SP</span>
          </div>
          <div className="flex items-center gap-2 text-white/50">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-[#C7A76C] text-sm"></i>
            </div>
            <span className="font-sans">(11) 95881-4422</span>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-sans text-white/35 text-xs">
            &copy; {new Date().getFullYear()} Bruno Castro Advocacia e Consultoria — CNPJ: 61.458.002/0001-13
          </p>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="font-sans text-white/25 hover:text-white/50 text-xs transition-colors duration-200 cursor-pointer"
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
